function productsOnload() {

    // START CART
    $.post(url("/ingresso/carrinho/update"), function (cart) {
        ajaxProducts(cart, "");
    }, "json");

    // ACTION BUTTONS
    $("[data-action]").click(function (e) {
        e.preventDefault();
        var data = $(this).data();

        $.post(data.action, function (cart) {
            ajaxProducts(cart, data);
        }, "json");
    });

    // AJAX
    function ajaxProducts(cart, data) {
        var modal_size = "sm"
        var modal = "#modal_" + modal_size;
        var modal_title = $(".modal_title_" + modal_size);
        var modal_content = $(".modal_content_" + modal_size);
        var total = $(".total");
        var btn_continue = $(".btn_continue");
        var total_count = 0;

        // REDIRECT
        if (cart.redirect) {
            window.location.href = cart.redirect;
        }

        // MESSAGE
        if (cart.message) {
            modal_title.html("");
            modal_content.html(cart.message);
            openModal(modal);
        }

        // ACTION REMOVE
        if (data.btn == "remove") {
            if ($(".item_quantity_" + data.id).text() == 1) {
                // remove control buttons & show add button
                $(".btn_add_" + data.id).removeClass("d-none").fadeIn();
                $(".btn_controls_" + data.id).addClass("d-none").fadeOut();
            }
        }

        // ITEMS
        if (cart.cart.products) {
            $.each(cart.cart.products, function (index, product) {

                total_count += product.total;

                // remove add button & show control buttons
                if (!$(".btn_add_" + product.id).hasClass("d-none")) {
                    $(".btn_add_" + product.id).addClass("d-none").fadeOut();
                    $(".btn_controls_" + product.id).removeClass("d-none").fadeIn();
                }

                $(".item_quantity_" + product.id).html(product.quantity);
            });
        }

        // TOTAL
        if (total_count) {
            total.html(formater.format(total_count));
            btn_continue.removeClass("disabled");
        } else {
            total.html("R$ 0,00");
            btn_continue.addClass("disabled");
        }
    }
}